export default class ViewModelBase{
	constructor(props){
		
	}
}